import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  Input
} from '@angular/core';
import { GUID_EMPTY } from '@core';
import { STColumn } from '@delon/abc/st';
import { _HttpClient, SettingsService } from '@delon/theme';
import { finalize } from 'rxjs';
import { DateFormatService } from 'src/app/shared/services/date-format.service';

@Component({
  selector: 'app-gl-posting-modal',
  templateUrl: './gl-posting-modal.component.html',
  styleUrls: ['./gl-posting-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GLPostingModalComponent implements OnInit {
  visible = false;

  loading = false;
  list: any[] = [];
  totalDr = 0;
  totalCr = 0;

  columns: STColumn[];

  @Input() url: string = '';
  @Input() docId: string = '';
  @Input() documentStatus: number = 2;
  localCurrency = '';
  constructor(
    private http: _HttpClient,
    private settings: SettingsService,
    private cdr: ChangeDetectorRef,
    private dateFormatService: DateFormatService
  ) {
    this.localCurrency = this.settings.user['company']?.currencyCode || 'MYR';
    this.columns = [
      {
        index: 'postDate',
        title: 'Date',
        type: 'date',
        dateFormat: this.dateFormatService.currentDateFormatValue,
        width: '110px'
      },
      { index: 'accountCode', title: 'Account #', width: '120px' },
      { index: 'accountName', title: 'Account Name' },
      { index: 'description', title: 'Description' },
      { index: 'referenceNo', title: 'Reference No.', width: '120px' },
      { index: 'supplierInvNo', title: 'Supplier Inv No.', width: '80px' },
      {
        index: 'debitLocal',
        title: 'Debit',
        width: '120px',
        type: 'currency',
        renderTitle: 'amountTitleTpl',
        render: 'debitTpl',
        statistical: 'sum',
        key: 'dr'
      },
      {
        index: 'creditLocal',
        title: 'Credit',
        width: '120px',
        type: 'currency',
        renderTitle: 'amountTitleTpl',
        render: 'creditTpl',
        statistical: 'sum',
        key: 'cr'
      }
    ];
  }

  ngOnInit(): void {
    return;
  }

  get isEmptyId() {
    return !this.docId || this.docId === '0' || this.docId === GUID_EMPTY;
  }

  show() {
    this.list = [];
    this.totalCr = this.totalCr = 0;
    this.visible = true;
    this.loading = true;
    this.http
      .get(this.url, { key: this.docId })
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe(res => {
        this.list = [...res];
        this.list.forEach(row => {
          this.totalDr += row.debitLocal;
          this.totalCr += row.creditLocal;
        });
      });
  }

  hide() {
    this.visible = false;
  }
}
